import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { GearSearchQueryResult } from '../../Model/GearSearchQueryResult';
import { GearSearchQueryRequest } from '../../Model/GearSearchQueryRequest';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { GearSearchExportRequest } from '../../Model/GearSearchExportRequest';

interface ISearchContext {
  data?: GearSearchQueryResult;
  isLoading?: boolean;
  queryRequest?: GearSearchQueryRequest;
  setQueryRequest: Dispatch<SetStateAction<GearSearchQueryRequest | undefined>>;
  compositeFilterDescriptor?: CompositeFilterDescriptor;
  setCompositeFilterDescriptor?: (newCompositeFilterDescriptor: CompositeFilterDescriptor | undefined) => void;
  handleTriggerExportToCsv?: (querySearchExport: GearSearchExportRequest) => void;
}

const defaultValue: ISearchContext = {
  setQueryRequest: () => {}
};

export const SearchContext = createContext<ISearchContext>(defaultValue);

export const useSearchContext = () => useContext(SearchContext);
